import React, { useEffect, useState } from "react";
import AcademyHead from "./AcademyHead";
import { IoClose } from "react-icons/io5";
import { useNavigate } from "react-router-dom";
import { getFetcher } from "../../../api/fetchers";
import { endpoints } from "../../../api/endpoints";
import { toast } from "react-toastify";
import Spinner from "../../components/spinner/Spinner";
import { parseStatics } from "../../function/parseStatics";

interface IBlog {
  id?: string;
  title: string;
  firstText: string;
  secondText: string;
  thirdText: string;
  blogType: number;
  images: any;
}

const AcademyBlogs: React.FC = () => {
  const [showBlogModal, setShowBlogModal] = useState<boolean>(false);
  const [blogs, setBlogs] = useState<IBlog[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [selectedBlogType, setSelectedBlogType] = useState<number>(1);

  const navigate = useNavigate();

  useEffect(() => {
    const getBlogs = async () => {
      try {
        const response = await getFetcher(endpoints.eAcademy.getBlogs);

        if (response.result) {
          setBlogs(response.blogs);
        } else {
          toast.error("Error");
        }
      } catch (error) {
        console.log(error);
      }
    };

    getBlogs();
  }, [selectedBlogType]);

  // LOADING
  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 300);
  }, []);

  // DEFAULT BLOG TYPE
  const blogTypes = [{ blogType: 1 }, { blogType: 2 }, { blogType: 3 }];

  // SELECTED BLOG TYPE
  const handleSelectedBlogType = (type: number) => {
    setSelectedBlogType(type);
    setShowBlogModal(true);
  };

  const textCut = (text: string, num: number) => {
    if (text.length > num) {
      return text.slice(0, num) + "...";
    }
    return text;
  };

  if (loading)
    return (
      <div>
        <Spinner />
      </div>
    );

  return (
    <div className=" flex flex-col gap-y-4 px-2 mb-40">
      <div>
        <AcademyHead title={"ECZA AKADEMİ BLOG"} />
      </div>

      <div className="h-full p-2  grid grid-cols-1 gap-5 w-full md:w-2/3 mx-auto ">
        {blogTypes?.map((type: any, i: number) => {
          return (
            // <div
            //   onClick={() => handleSelectedBlogType(type.blogType)}
            //   key={i}
            //   className="h-full lg:h-[300px] xl:h-[250px] rounded-xl shadow-lg hover:shadow-2xl cursor-pointer transition-all transform active:scale-95 w-full flex flex-col md:flex-row gap-y-3 sm:gap-y-0"
            // >
            //   <div className="flex-1 bg-primary-color p-8  rounded-none sm:rounded-l-xl h-1/2 md:h-full flex justify-center items-center">
            //     {type.blogType === 1 && (
            //       <div className=" w-1/2 h-full md:h-2/3 flex justify-center items-center bg-gray-200 white rounded-xl">
            //         <svg
            //           xmlns="http://www.w3.org/2000/svg"
            //           fill="none"
            //           viewBox="0 0 24 24"
            //           strokeWidth={1.5}
            //           stroke="currentColor"
            //           className="size-20"
            //         >
            //           <path
            //             strokeLinecap="round"
            //             strokeLinejoin="round"
            //             d="M12 6v12m-3-2.818.879.659c1.171.879 3.07.879 4.242 0 1.172-.879 1.172-2.303 0-3.182C13.536 12.219 12.768 12 12 12c-.725 0-1.45-.22-2.003-.659-1.106-.879-1.106-2.303 0-3.182s2.9-.879 4.006 0l.415.33M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
            //           />
            //         </svg>
            //       </div>
            //     )}
            //     {type.blogType === 2 && (
            //       <div className=" w-1/2 h-full md:h-2/3 flex justify-center items-center bg-gray-200 white rounded-xl">
            //         <svg
            //           xmlns="http://www.w3.org/2000/svg"
            //           fill="none"
            //           viewBox="0 0 24 24"
            //           strokeWidth={1.5}
            //           stroke="currentColor"
            //           className="size-20"
            //         >
            //           <path
            //             strokeLinecap="round"
            //             strokeLinejoin="round"
            //             d="M3 13.125C3 12.504 3.504 12 4.125 12h2.25c.621 0 1.125.504 1.125 1.125v6.75C7.5 20.496 6.996 21 6.375 21h-2.25A1.125 1.125 0 0 1 3 19.875v-6.75ZM9.75 8.625c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125v11.25c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 0 1-1.125-1.125V8.625ZM16.5 4.125c0-.621.504-1.125 1.125-1.125h2.25C20.496 3 21 3.504 21 4.125v15.75c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 0 1-1.125-1.125V4.125Z"
            //           />
            //         </svg>
            //       </div>
            //     )}
            //     {type.blogType === 3 && (
            //       <div className=" w-1/2 h-full md:h-2/3 flex justify-center items-center bg-gray-200 white rounded-xl">
            //         <svg
            //           xmlns="http://www.w3.org/2000/svg"
            //           fill="none"
            //           viewBox="0 0 24 24"
            //           strokeWidth={1.5}
            //           stroke="currentColor"
            //           className="size-20"
            //         >
            //           <path
            //             strokeLinecap="round"
            //             strokeLinejoin="round"
            //             d="M15.75 10.5V6a3.75 3.75 0 1 0-7.5 0v4.5m11.356-1.993 1.263 12c.07.665-.45 1.243-1.119 1.243H4.25a1.125 1.125 0 0 1-1.12-1.243l1.264-12A1.125 1.125 0 0 1 5.513 7.5h12.974c.576 0 1.059.435 1.119 1.007ZM8.625 10.5a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm7.5 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Z"
            //           />
            //         </svg>
            //       </div>
            //     )}
            //   </div>

            //   <div className=" flex-[2] flex flex-col justify-center items-center gap-y-5 md:gap-y-10">
            //     <div>
            //       <h3 className=" font-bold text-xl md:text-2xl">
            //         {type.blogType === 1 && "Ticari Faliyetler"}
            //         {type.blogType === 2 && "Satış Faliyetleri"}
            //         {type.blogType === 3 && "Sektörel Faliyetler"}
            //       </h3>
            //     </div>
            //     <div className="text-center">
            //       <p className=" text-color-opacity font-bold text-sm">
            //         {type.blogType === 1 &&
            //           "Ticari faliyerlerle ilgili bloglara bu bölümden ulaşabilirsiniz"}
            //         {type.blogType === 2 &&
            //           "Satış faliyetleri ilgili bloglara bu bölümden ulaşabilirsiniz"}
            //         {type.blogType === 3 &&
            //           "Sektörel faliyetler ilgili bloglara bu bölümden ulaşabilirsiniz"}
            //       </p>
            //     </div>
            //     <div className="text-center">
            //       <button className="mt-auto text-primary-color">
            //         Detaylar için tıklayınız
            //       </button>
            //     </div>
            //   </div>
            // </div>

            <div
              onClick={() => handleSelectedBlogType(type.blogType)}
              key={i}
              className="h-full lg:h-[300px] xl:h-[250px] rounded-xl shadow-lg hover:shadow-xl cursor-pointer transition-all transform active:scale-95 w-full flex flex-col md:flex-row gap-4"
            >
              <div className="flex-1 bg-primary-color p-8 rounded-none sm:rounded-l-xl h-40 md:h-full flex justify-center items-center">
                {type.blogType === 1 && (
                  <div className="w-20 h-20 md:w-24 md:h-24 flex justify-center items-center bg-gray-100 rounded-full">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      strokeWidth={1.5}
                      stroke="currentColor"
                      className="w-10 h-10"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M12 6v12m-3-2.818.879.659c1.171.879 3.07.879 4.242 0 1.172-.879 1.172-2.303 0-3.182C13.536 12.219 12.768 12 12 12c-.725 0-1.45-.22-2.003-.659-1.106-.879-1.106-2.303 0-3.182s2.9-.879 4.006 0l.415.33M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
                      />
                    </svg>
                  </div>
                )}
                {type.blogType === 2 && (
                  <div className="w-20 h-20 md:w-24 md:h-24 flex justify-center items-center bg-gray-100 rounded-full">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      strokeWidth={1.5}
                      stroke="currentColor"
                      className="w-10 h-10"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M3 13.125C3 12.504 3.504 12 4.125 12h2.25c.621 0 1.125.504 1.125 1.125v6.75C7.5 20.496 6.996 21 6.375 21h-2.25A1.125 1.125 0 0 1 3 19.875v-6.75ZM9.75 8.625c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125v11.25c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 0 1-1.125-1.125V8.625ZM16.5 4.125c0-.621.504-1.125 1.125-1.125h2.25C20.496 3 21 3.504 21 4.125v15.75c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 0 1-1.125-1.125V4.125Z"
                      />
                    </svg>
                  </div>
                )}
                {type.blogType === 3 && (
                  <div className="w-20 h-20 md:w-24 md:h-24 flex justify-center items-center bg-gray-100 rounded-full">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      strokeWidth={1.5}
                      stroke="currentColor"
                      className="w-10 h-10"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M15.75 10.5V6a3.75 3.75 0 1 0-7.5 0v4.5m11.356-1.993 1.263 12c.07.665-.45 1.243-1.119 1.243H4.25a1.125 1.125 0 0 1-1.12-1.243l1.264-12A1.125 1.125 0 0 1 5.513 7.5h12.974c.576 0 1.059.435 1.119 1.007ZM8.625 10.5a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm7.5 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Z"
                      />
                    </svg>
                  </div>
                )}
              </div>

              <div className="flex-[2] flex flex-col justify-center items-center gap-y-5 md:gap-y-8">
                <div>
                  <h3 className="font-bold text-xl md:text-2xl text-center">
                    {type.blogType === 1 && "Ticari Faliyetler"}
                    {type.blogType === 2 && "Satış Faliyetleri"}
                    {type.blogType === 3 && "Sektörel Faliyetler"}
                  </h3>
                </div>
                <div className="text-center">
                  <p className="text-color-opacity font-medium text-sm">
                    {type.blogType === 1 &&
                      "Ticari faliyetlerle ilgili bloglara bu bölümden ulaşabilirsiniz."}
                    {type.blogType === 2 &&
                      "Satış faliyetleri ile ilgili bloglara bu bölümden ulaşabilirsiniz."}
                    {type.blogType === 3 &&
                      "Sektörel faliyetlerle ilgili bloglara bu bölümden ulaşabilirsiniz."}
                  </p>
                </div>
                <div className="text-center">
                  <button className="mt-auto text-primary-color font-semibold hover:underline">
                    Detaylar için tıklayınız
                  </button>
                </div>
              </div>
            </div>
          );
        })}
      </div>

      {/* BLOG MODAL*/}
      {showBlogModal && (
        <div className="fixed inset-0 w-full h-full bg-black bg-opacity-75 flex justify-center items-center z-50">
          <div
            onClick={() => setShowBlogModal(false)}
            className="absolute w-full h-full"
          ></div>
          <div
            className="relative w-11/12 md:w-11/12 xl:w-11/12 h-[90%] bg-white flex flex-col justify-start items-start rounded-xl p-4 overflow-y-auto"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="w-full flex justify-center items-center mb-6">
              <h3 className="text-xl md:text-2xl font-bold text-primary-color text-center">
                {selectedBlogType === 1 && "Ticari Faaliyetler"}
                {selectedBlogType === 2 && "Satış Faaliyetleri"}
                {selectedBlogType === 3 && "Sektörel Faaliyetler"}
              </h3>
            </div>
            <div className="w-full h-full">
              <div className="ml-2 mb-4">
                <h3 className="text-lg md:text-xl">
                  {selectedBlogType === 1 && (
                    <div className="flex gap-x-2">
                      <p className="font-semibold text-primary-color">
                        Ticari Faaliyetler
                      </p>
                      <p>ile ilgili bloglar.</p>
                    </div>
                  )}
                  {selectedBlogType === 2 && (
                    <div className="flex gap-x-2">
                      <p className="font-semibold text-primary-color">
                        Satış Faaliyetleri
                      </p>
                      <p>ile ilgili bloglar.</p>
                    </div>
                  )}
                  {selectedBlogType === 3 && (
                    <div className="flex gap-x-2">
                      <p className="font-semibold text-primary-color">
                        Sektörel Faaliyetler
                      </p>
                      <p>ile ilgili bloglar.</p>
                    </div>
                  )}
                </h3>
              </div>

              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mt-4">
                {(() => {
                  let filteredBlogs = blogs;
                  if (selectedBlogType === 1) {
                    filteredBlogs = blogs.filter((blog) => blog.blogType === 1);
                  } else if (selectedBlogType === 2) {
                    filteredBlogs = blogs.filter((blog) => blog.blogType === 2);
                  } else if (selectedBlogType === 3) {
                    filteredBlogs = blogs.filter((blog) => blog.blogType === 3);
                  }
                  return filteredBlogs.map((blog: IBlog, i: number) => {
                    const parsedImages = parseStatics(blog.images);
                    return (
                      <div
                        key={i}
                        className="flex flex-col bg-white rounded-lg shadow-md overflow-hidden transform transition-all active:scale-95 hover:shadow-xl cursor-pointer"
                        onClick={() =>
                          navigate(`/academy/blog-detail/${blog?.id}`)
                        }
                      >
                        <img
                          src={parsedImages[0]}
                          alt={blog.title}
                          className="object-cover w-full h-48"
                        />
                        <div className="p-4 flex flex-col justify-between">
                          <h2 className="text-xl font-semibold text-gray-800">
                            {blog.title}
                          </h2>
                          <p className="text-gray-600 mt-2">
                            {textCut(blog.firstText, 70)}
                          </p>
                          <button className="mt-auto text-primary-color">
                            Detaylar için tıklayınız
                          </button>
                        </div>
                      </div>
                    );
                  });
                })()}
              </div>
            </div>

            {/* Close Button */}
            <div className="absolute top-2 right-2">
              <IoClose
                onClick={() => setShowBlogModal(false)}
                className="text-primary-color text-2xl cursor-pointer"
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AcademyBlogs;
